import { ModulPrWertFilter } from "../ws/modul/modul-pr-wert-filter.model";

 
 
export class FilterWertRow {

    modulPrWertFilterLinks!: ModulPrWertFilter;
    modulPrWertFilterRechts!: ModulPrWertFilter;

}
 

   